module.exports = __webpack_public_path__ + "static/img/2-3-普通换货.b71ee0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-3-普通换货.png
// module id = 1315
// module chunks = 0